/* tslint:disable */
/* eslint-disable */
/**
 * WebCore
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BCCADMINAPIControllersDeploymentControllerProductionPublishRequest } from '../Models';
// @ts-ignore
import type { BCCADMINAPIControllersDeploymentControllerPublishContentRequest } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsDeploymentBulkResult } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsDeploymentPageAnalysis } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsDeploymentSummary } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsPageOutOfSyncItem } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsSingletonOutOfSyncItem } from '../Models';
// @ts-ignore
import type { BCCADMINServicesServicesProductionPublishOverview } from '../Models';
// @ts-ignore
import type { BCCADMINServicesServicesPruneUnchangedResult } from '../Models';
// @ts-ignore
import type { DeploymentQueueItem } from '../Models';
/**
 * DeploymentApi - axios parameter creator
 */
export const DeploymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentDeploymentQueueDeployPost: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/deployment-queue/deploy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentDeploymentQueueGet: async (target?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/deployment-queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [contentId] 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentDiffGet: async (contentId?: string, target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/diff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contentId !== undefined) {
                localVarQueryParameter['contentId'] = contentId;
            }

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentLockGet: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/lock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {boolean} [includeAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageOutOfSyncAnalysisGet: async (target?: string, includeAll?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/page/out-of-sync/analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            if (includeAll !== undefined) {
                localVarQueryParameter['includeAll'] = includeAll;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageOutOfSyncDeployPost: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/page/out-of-sync/deploy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageOutOfSyncGet: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/page/out-of-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPagePurgeLegacyRecordFilesPost: async (target?: string, dryRun?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/page/purge-legacy-record-files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageStorageOrphansGet: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/page/storage-orphans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPreviewRepairPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/preview/repair`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPreviewRepairScanPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/preview/repair-scan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPreviewRepairStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/preview/repair/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPreviewStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/preview/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentProductionOverviewGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/production/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [contentTypeId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentProductionOverviewItemsGet: async (contentTypeId?: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/production/overview/items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contentTypeId !== undefined) {
                localVarQueryParameter['contentTypeId'] = contentTypeId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BCCADMINAPIControllersDeploymentControllerProductionPublishRequest} [bCCADMINAPIControllersDeploymentControllerProductionPublishRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentProductionPublishPost: async (bCCADMINAPIControllersDeploymentControllerProductionPublishRequest?: BCCADMINAPIControllersDeploymentControllerProductionPublishRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/production/publish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bCCADMINAPIControllersDeploymentControllerProductionPublishRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPromotePost: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/promote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BCCADMINAPIControllersDeploymentControllerPublishContentRequest} [bCCADMINAPIControllersDeploymentControllerPublishContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPublishContentPost: async (bCCADMINAPIControllersDeploymentControllerPublishContentRequest?: BCCADMINAPIControllersDeploymentControllerPublishContentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/publish-content`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bCCADMINAPIControllersDeploymentControllerPublishContentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [contentId] 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentRenderPairGet: async (contentId?: string, target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/render-pair`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contentId !== undefined) {
                localVarQueryParameter['contentId'] = contentId;
            }

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSchemaKeyLanguageDeployPreviewPost: async (schemaKey: string, language: string, slug?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaKey' is not null or undefined
            assertParamExists('apiDeploymentSchemaKeyLanguageDeployPreviewPost', 'schemaKey', schemaKey)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('apiDeploymentSchemaKeyLanguageDeployPreviewPost', 'language', language)
            const localVarPath = `/api/deployment/{schemaKey}/{language}/deploy/preview`
                .replace('{schemaKey}', encodeURIComponent(String(schemaKey)))
                .replace('{language}', encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSchemaKeyLanguageDeployProductionPost: async (schemaKey: string, language: string, slug?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaKey' is not null or undefined
            assertParamExists('apiDeploymentSchemaKeyLanguageDeployProductionPost', 'schemaKey', schemaKey)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('apiDeploymentSchemaKeyLanguageDeployProductionPost', 'language', language)
            const localVarPath = `/api/deployment/{schemaKey}/{language}/deploy/production`
                .replace('{schemaKey}', encodeURIComponent(String(schemaKey)))
                .replace('{language}', encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSingletonOutOfSyncGet: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/singleton/out-of-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSummaryGet: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} target 
         * @param {boolean} [rebuildQueue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentTargetIntegrityScanPost: async (target: string, rebuildQueue?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'target' is not null or undefined
            assertParamExists('apiDeploymentTargetIntegrityScanPost', 'target', target)
            const localVarPath = `/api/deployment/{target}/integrity-scan`
                .replace('{target}', encodeURIComponent(String(target)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (rebuildQueue !== undefined) {
                localVarQueryParameter['rebuildQueue'] = rebuildQueue;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} target 
         * @param {string} [cursor] 
         * @param {number} [budgetSeconds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentTargetPruneUnchangedPost: async (target: string, cursor?: string, budgetSeconds?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'target' is not null or undefined
            assertParamExists('apiDeploymentTargetPruneUnchangedPost', 'target', target)
            const localVarPath = `/api/deployment/{target}/prune-unchanged`
                .replace('{target}', encodeURIComponent(String(target)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (budgetSeconds !== undefined) {
                localVarQueryParameter['budgetSeconds'] = budgetSeconds;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentTargetQueueResetPost: async (target: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'target' is not null or undefined
            assertParamExists('apiDeploymentTargetQueueResetPost', 'target', target)
            const localVarPath = `/api/deployment/{target}/queue/reset`
                .replace('{target}', encodeURIComponent(String(target)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} target 
         * @param {boolean} [rebuildSearch] 
         * @param {string} [xConfirmDestructive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentTargetRealignPost: async (target: string, rebuildSearch?: boolean, xConfirmDestructive?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'target' is not null or undefined
            assertParamExists('apiDeploymentTargetRealignPost', 'target', target)
            const localVarPath = `/api/deployment/{target}/realign`
                .replace('{target}', encodeURIComponent(String(target)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (rebuildSearch !== undefined) {
                localVarQueryParameter['rebuildSearch'] = rebuildSearch;
            }


            if (xConfirmDestructive != null) {
                localVarHeaderParameter['X-Confirm-Destructive'] = String(xConfirmDestructive);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BCCADMINAPIControllersDeploymentControllerPublishContentRequest} [bCCADMINAPIControllersDeploymentControllerPublishContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentUnpublishContentPost: async (bCCADMINAPIControllersDeploymentControllerPublishContentRequest?: BCCADMINAPIControllersDeploymentControllerPublishContentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/unpublish-content`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bCCADMINAPIControllersDeploymentControllerPublishContentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeploymentApi - functional programming interface
 */
export const DeploymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeploymentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentDeploymentQueueDeployPost(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDeploymentBulkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentDeploymentQueueDeployPost(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentDeploymentQueueDeployPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentDeploymentQueueGet(target?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeploymentQueueItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentDeploymentQueueGet(target, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentDeploymentQueueGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [contentId] 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentDiffGet(contentId?: string, target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentDiffGet(contentId, target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentDiffGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentLockGet(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentLockGet(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentLockGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {boolean} [includeAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPageOutOfSyncAnalysisGet(target?: string, includeAll?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BCCADMINBaseModelsDeploymentPageAnalysis>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPageOutOfSyncAnalysisGet(target, includeAll, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPageOutOfSyncAnalysisGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPageOutOfSyncDeployPost(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDeploymentBulkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPageOutOfSyncDeployPost(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPageOutOfSyncDeployPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPageOutOfSyncGet(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BCCADMINBaseModelsPageOutOfSyncItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPageOutOfSyncGet(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPageOutOfSyncGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPagePurgeLegacyRecordFilesPost(target?: string, dryRun?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPagePurgeLegacyRecordFilesPost(target, dryRun, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPagePurgeLegacyRecordFilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPageStorageOrphansGet(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPageStorageOrphansGet(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPageStorageOrphansGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPreviewRepairPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPreviewRepairPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPreviewRepairPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPreviewRepairScanPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPreviewRepairScanPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPreviewRepairScanPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPreviewRepairStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPreviewRepairStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPreviewRepairStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPreviewStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPreviewStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPreviewStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentProductionOverviewGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINServicesServicesProductionPublishOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentProductionOverviewGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentProductionOverviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [contentTypeId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentProductionOverviewItemsGet(contentTypeId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentProductionOverviewItemsGet(contentTypeId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentProductionOverviewItemsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BCCADMINAPIControllersDeploymentControllerProductionPublishRequest} [bCCADMINAPIControllersDeploymentControllerProductionPublishRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentProductionPublishPost(bCCADMINAPIControllersDeploymentControllerProductionPublishRequest?: BCCADMINAPIControllersDeploymentControllerProductionPublishRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDeploymentBulkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentProductionPublishPost(bCCADMINAPIControllersDeploymentControllerProductionPublishRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentProductionPublishPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPromotePost(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDeploymentBulkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPromotePost(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPromotePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BCCADMINAPIControllersDeploymentControllerPublishContentRequest} [bCCADMINAPIControllersDeploymentControllerPublishContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPublishContentPost(bCCADMINAPIControllersDeploymentControllerPublishContentRequest?: BCCADMINAPIControllersDeploymentControllerPublishContentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDeploymentBulkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPublishContentPost(bCCADMINAPIControllersDeploymentControllerPublishContentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPublishContentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [contentId] 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentRenderPairGet(contentId?: string, target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentRenderPairGet(contentId, target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentRenderPairGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentSchemaKeyLanguageDeployPreviewPost(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentSchemaKeyLanguageDeployPreviewPost(schemaKey, language, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentSchemaKeyLanguageDeployPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentSchemaKeyLanguageDeployProductionPost(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentSchemaKeyLanguageDeployProductionPost(schemaKey, language, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentSchemaKeyLanguageDeployProductionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentSingletonOutOfSyncGet(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BCCADMINBaseModelsSingletonOutOfSyncItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentSingletonOutOfSyncGet(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentSingletonOutOfSyncGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentSummaryGet(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDeploymentSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentSummaryGet(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentSummaryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} target 
         * @param {boolean} [rebuildQueue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentTargetIntegrityScanPost(target: string, rebuildQueue?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentTargetIntegrityScanPost(target, rebuildQueue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentTargetIntegrityScanPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} target 
         * @param {string} [cursor] 
         * @param {number} [budgetSeconds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentTargetPruneUnchangedPost(target: string, cursor?: string, budgetSeconds?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINServicesServicesPruneUnchangedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentTargetPruneUnchangedPost(target, cursor, budgetSeconds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentTargetPruneUnchangedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentTargetQueueResetPost(target: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentTargetQueueResetPost(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentTargetQueueResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} target 
         * @param {boolean} [rebuildSearch] 
         * @param {string} [xConfirmDestructive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentTargetRealignPost(target: string, rebuildSearch?: boolean, xConfirmDestructive?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentTargetRealignPost(target, rebuildSearch, xConfirmDestructive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentTargetRealignPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BCCADMINAPIControllersDeploymentControllerPublishContentRequest} [bCCADMINAPIControllersDeploymentControllerPublishContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentUnpublishContentPost(bCCADMINAPIControllersDeploymentControllerPublishContentRequest?: BCCADMINAPIControllersDeploymentControllerPublishContentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentUnpublishContentPost(bCCADMINAPIControllersDeploymentControllerPublishContentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentUnpublishContentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeploymentApi - factory interface
 */
export const DeploymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeploymentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentDeploymentQueueDeployPost(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDeploymentBulkResult> {
            return localVarFp.apiDeploymentDeploymentQueueDeployPost(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentDeploymentQueueGet(target?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DeploymentQueueItem>> {
            return localVarFp.apiDeploymentDeploymentQueueGet(target, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [contentId] 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentDiffGet(contentId?: string, target?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentDiffGet(contentId, target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentLockGet(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentLockGet(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {boolean} [includeAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageOutOfSyncAnalysisGet(target?: string, includeAll?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<BCCADMINBaseModelsDeploymentPageAnalysis>> {
            return localVarFp.apiDeploymentPageOutOfSyncAnalysisGet(target, includeAll, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageOutOfSyncDeployPost(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDeploymentBulkResult> {
            return localVarFp.apiDeploymentPageOutOfSyncDeployPost(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageOutOfSyncGet(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BCCADMINBaseModelsPageOutOfSyncItem>> {
            return localVarFp.apiDeploymentPageOutOfSyncGet(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPagePurgeLegacyRecordFilesPost(target?: string, dryRun?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentPagePurgeLegacyRecordFilesPost(target, dryRun, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageStorageOrphansGet(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiDeploymentPageStorageOrphansGet(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPreviewRepairPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentPreviewRepairPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPreviewRepairScanPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentPreviewRepairScanPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPreviewRepairStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentPreviewRepairStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPreviewStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentPreviewStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentProductionOverviewGet(options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINServicesServicesProductionPublishOverview> {
            return localVarFp.apiDeploymentProductionOverviewGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [contentTypeId] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentProductionOverviewItemsGet(contentTypeId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentProductionOverviewItemsGet(contentTypeId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BCCADMINAPIControllersDeploymentControllerProductionPublishRequest} [bCCADMINAPIControllersDeploymentControllerProductionPublishRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentProductionPublishPost(bCCADMINAPIControllersDeploymentControllerProductionPublishRequest?: BCCADMINAPIControllersDeploymentControllerProductionPublishRequest, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDeploymentBulkResult> {
            return localVarFp.apiDeploymentProductionPublishPost(bCCADMINAPIControllersDeploymentControllerProductionPublishRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPromotePost(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDeploymentBulkResult> {
            return localVarFp.apiDeploymentPromotePost(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BCCADMINAPIControllersDeploymentControllerPublishContentRequest} [bCCADMINAPIControllersDeploymentControllerPublishContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPublishContentPost(bCCADMINAPIControllersDeploymentControllerPublishContentRequest?: BCCADMINAPIControllersDeploymentControllerPublishContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDeploymentBulkResult> {
            return localVarFp.apiDeploymentPublishContentPost(bCCADMINAPIControllersDeploymentControllerPublishContentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [contentId] 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentRenderPairGet(contentId?: string, target?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentRenderPairGet(contentId, target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSchemaKeyLanguageDeployPreviewPost(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentSchemaKeyLanguageDeployPreviewPost(schemaKey, language, slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSchemaKeyLanguageDeployProductionPost(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentSchemaKeyLanguageDeployProductionPost(schemaKey, language, slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSingletonOutOfSyncGet(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BCCADMINBaseModelsSingletonOutOfSyncItem>> {
            return localVarFp.apiDeploymentSingletonOutOfSyncGet(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSummaryGet(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDeploymentSummary> {
            return localVarFp.apiDeploymentSummaryGet(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} target 
         * @param {boolean} [rebuildQueue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentTargetIntegrityScanPost(target: string, rebuildQueue?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentTargetIntegrityScanPost(target, rebuildQueue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} target 
         * @param {string} [cursor] 
         * @param {number} [budgetSeconds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentTargetPruneUnchangedPost(target: string, cursor?: string, budgetSeconds?: number, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINServicesServicesPruneUnchangedResult> {
            return localVarFp.apiDeploymentTargetPruneUnchangedPost(target, cursor, budgetSeconds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentTargetQueueResetPost(target: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentTargetQueueResetPost(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} target 
         * @param {boolean} [rebuildSearch] 
         * @param {string} [xConfirmDestructive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentTargetRealignPost(target: string, rebuildSearch?: boolean, xConfirmDestructive?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentTargetRealignPost(target, rebuildSearch, xConfirmDestructive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BCCADMINAPIControllersDeploymentControllerPublishContentRequest} [bCCADMINAPIControllersDeploymentControllerPublishContentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentUnpublishContentPost(bCCADMINAPIControllersDeploymentControllerPublishContentRequest?: BCCADMINAPIControllersDeploymentControllerPublishContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentUnpublishContentPost(bCCADMINAPIControllersDeploymentControllerPublishContentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeploymentApi - object-oriented interface
 */
export class DeploymentApi extends BaseAPI {
    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentDeploymentQueueDeployPost(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentDeploymentQueueDeployPost(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentDeploymentQueueGet(target?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentDeploymentQueueGet(target, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [contentId] 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentDiffGet(contentId?: string, target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentDiffGet(contentId, target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentLockGet(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentLockGet(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {boolean} [includeAll] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPageOutOfSyncAnalysisGet(target?: string, includeAll?: boolean, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPageOutOfSyncAnalysisGet(target, includeAll, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPageOutOfSyncDeployPost(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPageOutOfSyncDeployPost(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPageOutOfSyncGet(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPageOutOfSyncGet(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {boolean} [dryRun] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPagePurgeLegacyRecordFilesPost(target?: string, dryRun?: boolean, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPagePurgeLegacyRecordFilesPost(target, dryRun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPageStorageOrphansGet(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPageStorageOrphansGet(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPreviewRepairPost(options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPreviewRepairPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPreviewRepairScanPost(options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPreviewRepairScanPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPreviewRepairStatusGet(options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPreviewRepairStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPreviewStatusGet(options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPreviewStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentProductionOverviewGet(options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentProductionOverviewGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [contentTypeId] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentProductionOverviewItemsGet(contentTypeId?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentProductionOverviewItemsGet(contentTypeId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BCCADMINAPIControllersDeploymentControllerProductionPublishRequest} [bCCADMINAPIControllersDeploymentControllerProductionPublishRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentProductionPublishPost(bCCADMINAPIControllersDeploymentControllerProductionPublishRequest?: BCCADMINAPIControllersDeploymentControllerProductionPublishRequest, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentProductionPublishPost(bCCADMINAPIControllersDeploymentControllerProductionPublishRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPromotePost(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPromotePost(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BCCADMINAPIControllersDeploymentControllerPublishContentRequest} [bCCADMINAPIControllersDeploymentControllerPublishContentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPublishContentPost(bCCADMINAPIControllersDeploymentControllerPublishContentRequest?: BCCADMINAPIControllersDeploymentControllerPublishContentRequest, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPublishContentPost(bCCADMINAPIControllersDeploymentControllerPublishContentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [contentId] 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentRenderPairGet(contentId?: string, target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentRenderPairGet(contentId, target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} schemaKey 
     * @param {string} language 
     * @param {string} [slug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentSchemaKeyLanguageDeployPreviewPost(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentSchemaKeyLanguageDeployPreviewPost(schemaKey, language, slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} schemaKey 
     * @param {string} language 
     * @param {string} [slug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentSchemaKeyLanguageDeployProductionPost(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentSchemaKeyLanguageDeployProductionPost(schemaKey, language, slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentSingletonOutOfSyncGet(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentSingletonOutOfSyncGet(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentSummaryGet(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentSummaryGet(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} target 
     * @param {boolean} [rebuildQueue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentTargetIntegrityScanPost(target: string, rebuildQueue?: boolean, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentTargetIntegrityScanPost(target, rebuildQueue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} target 
     * @param {string} [cursor] 
     * @param {number} [budgetSeconds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentTargetPruneUnchangedPost(target: string, cursor?: string, budgetSeconds?: number, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentTargetPruneUnchangedPost(target, cursor, budgetSeconds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} target 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentTargetQueueResetPost(target: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentTargetQueueResetPost(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} target 
     * @param {boolean} [rebuildSearch] 
     * @param {string} [xConfirmDestructive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentTargetRealignPost(target: string, rebuildSearch?: boolean, xConfirmDestructive?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentTargetRealignPost(target, rebuildSearch, xConfirmDestructive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BCCADMINAPIControllersDeploymentControllerPublishContentRequest} [bCCADMINAPIControllersDeploymentControllerPublishContentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentUnpublishContentPost(bCCADMINAPIControllersDeploymentControllerPublishContentRequest?: BCCADMINAPIControllersDeploymentControllerPublishContentRequest, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentUnpublishContentPost(bCCADMINAPIControllersDeploymentControllerPublishContentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

